package com.bikompanion.domain

/**
 * Which of the two mutually exclusive point layers the map is drawing.
 *
 * Exclusive rather than stacked: both answer "where do I leave this bike", and drawn together
 * over a dense city the racks bury the stations whose numbers the rest of the screen is about.
 */
enum class MapLayerMode {
    /** Operator docking stations with live availability, from the bike-share feeds. */
    Stations,

    /**
     * OpenStreetMap `amenity=bicycle_parking` racks — every one in the world, read out of the
     * dataset shipped with the app a fixed cell of ground at a time and drawn by
     * `MapMarkersOverlay`. See `ParkingCell` and `BundledParkingRepository`.
     */
    Parking,
}
